module.exports = __webpack_public_path__ + "img/hr-level1_mining_tool_mask.53055b3f.png";